import {remote} from '../constants/environment';
import {defaultHeaders} from './headers';
import {IClient} from '../interfaces/dtos';
import {IProductListResponse} from '../interfaces/services';
import {customFetch as fetch, remoteCall} from '../utils/services';

export const getSalesmanProducts = async (
  priceListId?: string,
  paymentOptionId?: string,
  token?: string,
): Promise<IProductListResponse> => {
  const remoteURI = remote.getSalesmanProductsListUri();
  return (await remoteCall(
    async () => {
      return await fetch(remoteURI, {
        method: 'GET',
        headers: {
          ...defaultHeaders,
          'token-session': token ?? '',
        },
      });
    },
    async (response: Response) => {
      if (response.status === 200) {
        const data = await response.json();

        if (data.success && data.payload) {
          const success = true;
          return {
            success,
            payload: data.payload as IClient[],
          };
        } else {
          return {
            success: false,
            payload: null,
          };
        }
      }
    },
    remoteURI,
  )) as IProductListResponse;
};
